export default {
  computed: {
    accordionItems() {
      return [];
    },
  },

  methods: {
    handleGroupToggle(index, isOpen) {
      if (!isOpen) {
        return;
      }
      this.accordionItems.forEach((item, i) => {
        if (i === index || !item.children) {
          return;
        }
        const refName = item.ref || `group-${i}`;
        const ref = this.$refs[refName];
        const component = Array.isArray(ref) ? ref[0] : ref;
        if (component) {
          component.close();
        }
      });
    },
  },
};
